/**
 * ERR-403 権限がありません（03 6.3 ERR-403）。URL は変えずに出す。API が 403 を返したときだけ trace_id を出す。
 */
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { errorText, t } from '@pcrm/shared';
import { TraceIdText } from '../../components/feedback/ErrorPanel';
import { usePageTitle } from '../../lib/page-title';

export function ForbiddenPage({ trace_id }: { trace_id?: string }) {
  const navigate = useNavigate();
  usePageTitle('権限がありません');
  return (
    <Box sx={{ p: { xs: 1.5, md: 3 }, display: 'flex', justifyContent: 'center' }}>
      <Paper sx={{ p: 4, maxWidth: 560, width: '100%', textAlign: 'center' }}>
        <Typography variant="h4" component="h1" sx={{ fontSize: { xs: 22, md: 28 }, mb: 2 }}>
          {t('FE-MSG-E-004')}
        </Typography>
        <Typography sx={{ mb: 3 }}>{errorText('AUTH_001')}</Typography>
        <TraceIdText trace_id={trace_id} />
        <Box sx={{ mt: 3 }}>
          <Button variant="contained" onClick={() => navigate('/')}>
            ダッシュボードへ
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
